import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';
export const OverflowMenuIcon = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="black">
    <path
      d="M11.5263 9.47368C12.9237 9.47368 14.0526 10.6026 14.0526 12C14.0526 13.3974 12.9237 14.5263 11.5263 14.5263C10.1289 14.5263 9 13.3974 9 12C9 10.6026 10.1289 9.47368 11.5263 9.47368ZM9 2.52632C9 3.92368 10.1289 5.05263 11.5263 5.05263C12.9237 5.05263 14.0526 3.92368 14.0526 2.52632C14.0526 1.12895 12.9237 0 11.5263 0C10.1289 0 9 1.12895 9 2.52632ZM9 21.4737C9 22.8711 10.1289 24 11.5263 24C12.9237 24 14.0526 22.8711 14.0526 21.4737C14.0526 20.0763 12.9237 18.9474 11.5263 18.9474C10.1289 18.9474 9 20.0763 9 21.4737Z"
      fill="#000A14"
    />
  </svg>
);
